// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ChartBarIcon } from '@moia-dev/pace-icons'
import { FleetPerformanceOverviewAreaRoutes } from './FleetPerformanceOverviewAreaRoutes'

export const FleetPerformanceOverviewAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetPerformanceOverviewAreaRoutes.route}
      Icon={ChartBarIcon}
    />
  )
}
